import { useHistory } from 'react-router-dom';
import { ReactComponent as ReferralSVG } from 'icons/sd-referral.svg';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';
import {
  REFERRAL_ACTION_OPTIONS,
  NEXT_CONSULTATION_OPTIONS,
} from 'config/referral';

const ReferralCard = ({ data, date }) => {
  const history = useHistory();

  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  const { id, referralActionType, doctor, nextConsultation, reason } = data;

  const generateFullName = (user) =>
    user ? [user.firstName, user.lastName].filter(Boolean).join(' ') : null;

  const title =
    REFERRAL_ACTION_OPTIONS.find((r) => r.id === referralActionType)
      ?.cardTitle || 'nurse teleconsultation';

  const nextConsultationLabel = NEXT_CONSULTATION_OPTIONS.find(
    (n) => n.id === nextConsultation,
  )?.title;

  const reasonLabel =
    reason?.length > 57 ? `${reason.slice(0, 57)}...` : reason;

  const DesktopView = (
    <article
      className="grid-cards pointer"
      onClick={() => history.push(`/referrals/${id}`)}
    >
      <div className="apps-card-left-new" style={{ gridColumn: 'span 10' }}>
        <div className="mr6">
          <ReferralSVG />
        </div>
        <div className="apps-card-meta">
          <div className="apps-card-app-title-new">Referral for {title}</div>
          <div className="flex flex-row" style={{ gap: '6px' }}>
            <div>
              {doctor && <p className="apps-card-app-desc-new">Doctor:</p>}
              {nextConsultation && (
                <p className="apps-card-app-desc-new">Next consultation:</p>
              )}
              {reason && <p className="apps-card-app-desc-new">Reason:</p>}
            </div>
            <div className="flex flex-column">
              {doctor && (
                <p className="apps-card-app-desc-new">
                  {generateFullName(doctor)}
                </p>
              )}
              {nextConsultation && (
                <p className="apps-card-app-desc-new">
                  {nextConsultationLabel}
                </p>
              )}
              {reason && (
                <p className="apps-card-app-desc-new">{reasonLabel}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 2', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">{date}</p>
        </div>
      </div>
    </article>
  );

  const MobileView = (
    <article
      className="grid-cards pointer"
      onClick={() => history.push(`/referrals/${id}`)}
    >
      <div className="apps-card-left-new" style={{ gridColumn: 'span 10' }}>
        <div className="apps-card-meta ">
          <div className="apps-card-app-title-new">Referral for {title}</div>
          <div className="flex flex-row" style={{ gap: '6px' }}>
            <div>
              {doctor && <p className="apps-card-app-desc-new">Doctor:</p>}
              {nextConsultation && (
                <p className="apps-card-app-desc-new">Next consultation:</p>
              )}
              {reason && <p className="apps-card-app-desc-new">Reason:</p>}
            </div>
            <div className="flex flex-column">
              {doctor && (
                <p className="apps-card-app-desc-new">
                  {generateFullName(doctor)}
                </p>
              )}
              {nextConsultation && (
                <p className="apps-card-app-desc-new">
                  {nextConsultationLabel}
                </p>
              )}
              {reason && (
                <p className="apps-card-app-desc-new">{reasonLabel}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 2', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">{date}</p>
        </div>
      </div>
    </article>
  );

  return isMobile ? MobileView : DesktopView;
};

export default ReferralCard;
